import React, {Component} from 'react';
import {withStyles, Grid, Container} from '@material-ui/core';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import { REMOVE_POST, UPDATE_POST } from '../core/handlers.actions';
import PendingPostTable from './table/pending.post';
import { IPost } from '../core/models/post';
import AddEditPostCard from './card/new.post';

const styles = (theme:any) => ({ 
    root: {flrexGrow: 1, marginTop: theme.spacing(5)},
    paper: {padding: theme.spacing(2), textAlign: 'center' as any, color: theme.palette.text.secondary}
});

interface Props {
    classes: any;
    deletePost: (id:string) => void;
    updatePost: (data:any) => void;
}

interface State {
    current: IPost | null;
    edit: boolean;
}

class Posts extends Component<Props, State> {
    state:State = {edit: false, current:null};

    constructor(props:Props){
        super(props);
        this.editHandler = this.editHandler.bind(this);
        this.reset = this.reset.bind(this);
    }

    public editHandler(post:IPost){        
        this.setState({...this.state, current: post, edit: true}); 
    }
    public reset(){        
        this.setState({...this.state, edit: false});
    }

    public render(){
        const {classes} = this.props;
        const {edit, current} = this.state;                
        return(
            <Container maxWidth="lg"  className={classes.root}>
               <Grid container  spacing={3}  justify="center" >  
                    {edit?
                        <Grid item xs={12}>
                            <AddEditPostCard tags={current?.tags} post={current} action={this.reset} edit={true} featuredTag={current?.featuredTag} tagsRef={current?.tagsRef}/>
                        </Grid>
                    :null}              
                    <Grid item xs={12}>
                        <PendingPostTable editPost={this.editHandler}/>
                    </Grid>
               </Grid>
            </Container>
        );
    }
}
// const mapProps = (app:any) => ({tags: app.rootReducer.tags, pending});
const mapDispatch = (dispatch:Dispatch) => ({
    deletePost: (id:string) => dispatch({type: REMOVE_POST, payload: id}),
    updatePost: (data:any) => dispatch({type: UPDATE_POST, payload: data})
}); 
export default connect(null, mapDispatch)(withStyles(styles)(Posts));